import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import Select from "react-select";
import FacilityDropdownWithCustomModal from "../../components/FacilityDropdownWithCustomModal";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { del, get, post } from "../../services/api";
import { toast } from "react-toastify";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";
import Elements from "../../components/elements/Elements";

const FacilityForm = () => {
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("username");
  const organizationId = localStorage.getItem("organizationId");
  const centerId = localStorage.getItem("centerId");

  const [
    isCustomDropdownValuesModalVisible,
    setIsCustomDropdownValuesModalVisible,
  ] = useState(false);
  const [customDropdownName, setCustomDropdownName] = useState("");
  const [facilityCategoryOptions, setFacilityCategoryOptions] = useState([]);
  const [availableFacilitiesOptions, setAvailableFacilitiesOptions] = useState(
    []
  );
  const [peakBookingOptions, setPeakBookingOptions] = useState([]);
  const [offPeakBookingOptions, setOffPeakBookingOptions] = useState([]);
  const [assignResourceOptions, setAssignResourceOptions] = useState([]);
  const [availabeDays, setAvailabeDays] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const [elementsData, setElementsData] = useState([]);
  const [fileCounts, setFileCounts] = useState({});
  const [fileUrls, setFileUrls] = useState({});

  useEffect(() => {
    fetchCommonSettings("facilityCategory", setFacilityCategoryOptions);
    fetchCommonSettings("availableFacilities", setAvailableFacilitiesOptions);
    fetchCommonSettings("peakBookingTime", setPeakBookingOptions);
    fetchCommonSettings("offPeakBookingTime", setOffPeakBookingOptions);
    fetchCommonSettings("assignResource", setAssignResourceOptions);
    fetchCommonSettings("availabledays", setAvailabeDays);
  }, []);

  const fetchFacilities = async () => {
    try {
      const response = await get(`Facility?centerId=${centerId}`);
      console.log("Facility", response);
      setFilteredData(response);
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, []);

  useEffect(() => {
    const fetchElements = async () => {
      try {
        const elementsResponse = await get("Dropdown/GetElements", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setElementsData(elementsResponse);
      } catch (error) {
        console.error("Error fetching elements:", error);
      }
    };

    fetchElements();
  }, [token]);

  const fetchCommonSettings = async (key, setFunction) => {
    try {
      const res = await get(`Facility/dropdowns/${key}`);
      console.log(`${key}`, res);
      setFunction(res || []);
    } catch (err) {
      console.error(`Failed fetching ${key}`, err);
    }
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    trigger,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      facilityId: 0,
      facilityDescription: "",
      facilityDetailDescription: "",
      dimensions: "",
      settingCapacity: "",
      peakBookingTime: null,
      offPeakBookingTime: null,
      facilityCategory: null,
      availableFacilities: null,
      assignResource: null,
      createdBy: "",
      updatedBy: "",
      elements: [
        {
          name: "",
          description: "",
          createdBy: localStorage.getItem("userId"),
          elementDetail: {
            value: "",
            description: "",
            effectiveDate: null,
            endDate: null,
            createdBy: localStorage.getItem("userId"),
            fileName: "",
            filePath: "",
            base64String: "",
            formId: 0,
          },
        },
      ],
    },
  });

  const facilityId = watch("facilityId");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "elements",
  });

  const handleAttachmentFileChange = (event, index) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue(`elements[${index}].elementDetail.base64String`, base64String);
        setValue(`elements[${index}].elementDetail.fileName`, file.name);
        trigger(`elements[${index}].elementDetail`);
        setFileCounts((prev) => ({ ...prev, [index]: 1 }));
        setFileUrls((prev) => ({ ...prev, [index]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    const user = localStorage.getItem("userId");
    console.log("data", JSON.stringify(data));

    const elements = data.elements.map((element) => ({
      id: element.id || 0,
      createdBy: element.createdBy || localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      elementId: element.name?.value || 0,
      description: element.description || "",
      value: element.elementDetail.value || "",
      effectiveDate: element.elementDetail.effectiveDate || null,
      endDate: element.elementDetail.endDate || null,
      code: element.code || "",
      fileName: element.elementDetail.fileName || "",
      filePath: element.elementDetail.filePath || "",
      base64String: element.elementDetail.base64String || "",
    }));

    const payload = {
      id: data.facilityId || 0,
      description: data.facilityDescription,
      detailDescription: data.facilityDetailDescription,
      dimensions: data.dimensions,
      seatingCapacity: parseInt(data.settingCapacity) || 0,
      categoryId: data.facilityCategory,
      availableFacilityIds: data.availableFacilities || [],
      peakBookingRates: data.peakBookingTime
        ? data.peakBookingTime.map((id) => ({
            timeSlotId: id,
            perHourRate: parseInt(data.peakBookingRate) || 0,
          }))
        : [],
      offPeakBookingRates: data.offPeakBookingTime
        ? data.offPeakBookingTime.map((id) => ({
            timeSlotId: id,
            perHourRate: parseInt(data.OffpeakBookingRate) || 0,
          }))
        : [],
      resourceIds: data.assignResource || [],
      availableDays: data.availabeDays || [],
      createdOn: new Date().toISOString(),
      createdBy: data.facilityId === 0 ? user : data.createdBy,
      updatedOn: new Date().toISOString(),
      updatedBy: data.facilityId !== 0 ? user : data.updatedBy,
      elementDetails: elements,
      centerId: centerId,
    };

    console.log("Payload to send:", JSON.stringify(payload));

    try {
      const response = await post("Facility", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "text",
      });
      console.log("response", response);
      if (response === "Saved Successfully") {
        toast.success("Saved successfully!");
        resetForm();
        fetchFacilities();
      } else {
        toast.error("Unexpected response: " + response);
      }
    } catch (error) {
      console.error("Error saving facility:", error);
      toast.error("Something went wrong!");
    }
  };

  const resetForm = () => {
    reset({
      facilityDescription: "",
      facilityDetailDescription: "",
      dimensions: "",
      settingCapacity: "",
      facilityCategory: null,
      availableFacilities: null,
      peakBookingTime: null,
      offPeakBookingTime: null,
      assignResource: null,
      peakBookingRate: "",
      OffpeakBookingRate: "",
      availabeDays: null,
      elements: [
        {
          name: "",
          description: "",
          createdBy: localStorage.getItem("userId"),
          elementDetail: {
            value: "",
            description: "",
            effectiveDate: null,
            endDate: null,
            createdBy: localStorage.getItem("userId"),
            fileName: "",
            filePath: "",
            base64String: "",
            formId: 0,
          },
        },
      ],
    });
    setFileCounts({});
    setFileUrls({});
  };

  const renderDropdownS = (name, label, options) => (
    <div className="col-md-6">
      <label className="form-label">
        {label} <span className="text-danger fs-9">*</span>
      </label>
      <div className="d-flex gap-2">
        <div className="w-100">
          <Controller
            name={name}
            control={control}
            rules={{ required: "This field is required." }}
            render={({ field }) => (
              <Select
                {...field}
                className="react-select-style"
                classNamePrefix="react-select-style-pref"
                options={options.map((item) => ({
                  value: item.id,
                  label: item.value,
                }))}
                isClearable
                onChange={(selectedOption) =>
                  field.onChange(selectedOption ? selectedOption.value : "")
                }
                value={
                  options
                    .map((item) => ({
                      value: item.id,
                      label: item.value,
                    }))
                    .find((option) => option.value === field.value) || null
                }
              />
            )}
          />
        </div>
        <div>
          <button
            type="button"
            className="btn btn-outline-primary"
            style={{ padding: "5.5px 10px" }}
            onClick={() => handleCustomDropdownSetting(name)}
          >
            <i className="fas fa-plus"></i>
          </button>
        </div>
      </div>
      {errors[name] && (
        <small className="text-danger">{errors[name].message}</small>
      )}
    </div>
  );

  const renderDropdown = (name, label, options) => (
    <div className="col-md-6">
      <label className="form-label">
        {label} <span className="text-danger fs-9">*</span>
      </label>
      <div className="d-flex gap-2">
        <div className="w-100">
          <Controller
            name={name}
            control={control}
            rules={{ required: "This field is required." }}
            render={({ field }) => (
              <Select
                {...field}
                isMulti
                className="react-select-style"
                classNamePrefix="react-select-style-pref"
                options={options.map((item) => ({
                  value: item.id,
                  label: item.value,
                }))}
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions
                    ? selectedOptions.map((option) => option.value)
                    : [];
                  field.onChange(selectedValues);
                }}
                value={options
                  .map((item) => ({
                    value: item.id,
                    label: item.value,
                  }))
                  .filter((option) => field.value?.includes(option.value))}
              />
            )}
          />
        </div>
        {name !== "availabeDays" && (
          <div>
            <button
              type="button"
              className="btn btn-outline-primary"
              style={{ padding: "5.5px 10px" }}
              onClick={() => handleCustomDropdownSetting(name)}
            >
              <i className="fas fa-plus"></i>
            </button>
          </div>
        )}
      </div>
      {errors[name] && (
        <small className="text-danger">{errors[name].message}</small>
      )}
    </div>
  );

  const handleCustomDropdownSetting = (dropdownKey) => {
    setCustomDropdownName(dropdownKey);
    setIsCustomDropdownValuesModalVisible(true);
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "mrt-row-numbers",
        header: "Sr No.",
        enableColumnOrdering: false,
        enableEditing: false, 
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: "description",
        header: "Name",
        // size: 150,
      },
      {
        accessorKey: "code",
        header: "Code",
        // size: 100,
        Cell: ({ row }) => `C-${row.original.id}`,
      },
      {
        accessorKey: "detailDescription",
        header: "Description",
        // size: 200,
      },
      {
        accessorKey: "actions",
        header: "Action",
        size: 120,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="fas fa-pencil"></i>
            </button>
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleDeleteClick(row.original.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const exportToExcel = () => {
    const filteredExportData = filteredData.map((row, index) => ({
      "Sr No": index + 1,
      Name: row.description,
      Code: `C-${row.id}`,
      Description: row.detailDescription,
    }));

    const worksheet = XLSX.utils.json_to_sheet(filteredExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Facilities");
    XLSX.writeFile(workbook, "FacilitiesList.xlsx");
  };

  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
    });
  };

  const exportToPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;

    const roleIdLoggedIn = localStorage.getItem("roleId");
    const orgLogoPath = localStorage.getItem("organizationLogoPath");
    const centerLogoPath = localStorage.getItem("centerLogoPath");
    const orgLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${orgLogoPath}`;
    const centerLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${centerLogoPath}`;

    let logoToUse = logo; // Default imported logo
    const sidebarLogoUrl =
      roleIdLoggedIn == "2" ? orgLogo : roleIdLoggedIn == "3" ? centerLogo : null;

    if (sidebarLogoUrl) {
      try {
        logoToUse = await loadImage(sidebarLogoUrl);
      } catch (error) {
        console.warn(
          "Failed to load sidebar logo, falling back to default.",
          error
        );
      }
    }

    // doc.addImage(logoToUse, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Facilities List";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const includedColumns = columns.filter(
      (column) => column.accessorKey !== "actions" && column.accessorKey !== "mrt-row-numbers"
    );

    const headers = ["Sr No.", ...includedColumns.map((col) => col.header)];

    const bodyData = filteredData.map((row, index) => {
      return [
        index + 1,
        row.description,
        `C-${row.id}`,
        row.detailDescription,
      ];
    });

    doc.autoTable({
      head: [headers],
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
      },
    });

    doc.save("FacilitiesList.pdf");
  };

  const handleEditClick = async (rowId) => {
    try {
      console.log("rowid", JSON.stringify(rowId));

      const {
        id,
        description,
        detailDescription,
        dimensions,
        seatingCapacity,
        categoryId,
        availableFacilityIds,
        resourceIds,
        availableDays,
        createdBy,
        peakBookingRates,
        offPeakBookingRates,
        elementDetailsDto,
      } = rowId;

      const peakBookingTime = peakBookingRates?.map((p) => p.timeSlotId) || [];
      const offPeakBookingTime =
        offPeakBookingRates?.map((p) => p.timeSlotId) || [];
      const peakBookingRate =
        peakBookingRates?.[0]?.perHourRate?.toString() || "";
      const OffpeakBookingRate =
        offPeakBookingRates?.[0]?.perHourRate?.toString() || "";

      const mappedElements =
        elementDetailsDto?.length > 0
          ? elementDetailsDto.map((element, index) => {
              const matchingElement = elementsData.find(
                (item) => item.id === element.elementId
              );

              const fileUrl = element.filePath
                ? `${process.env.REACT_APP_LIVE_DOMAIN_URL}/ExternalImages/${element.filePath}`
                : "";

              setFileCounts((prevCounts) => ({
                ...prevCounts,
                [index]: element.fileName ? 1 : 0,
              }));

              setFileUrls((prevUrls) => ({
                ...prevUrls,
                [index]: fileUrl,
              }));

              return {
                id: element.id || 0,
                createdBy: element.createdBy || localStorage.getItem("userId"),
                updatedBy: localStorage.getItem("userId"),
                name: matchingElement
                  ? { value: matchingElement.id, label: matchingElement.name }
                  : {
                      value: element.elementId || 0,
                      label: element.value || "",
                    },
                description: element.description || "",
                elementDetail: {
                  id: element.id || 0,
                  createdBy:
                    element.createdBy || localStorage.getItem("userId"),
                  updatedBy: localStorage.getItem("userId"),
                  formId: element.formId || 0,
                  elementId: element.elementId || 0,
                  value: element.value || "",
                  description: element.description || "",
                  effectiveDate: element.effectiveDate?.split("T")[0] || null,
                  endDate: element.endDate?.split("T")[0] || null,
                  code: element.code || "",
                  fileName: element.fileName || "",
                  filePath: element.filePath || "",
                  base64String: element.base64String || "",
                },
                code: element.code || "",
              };
            })
          : [
              {
                id: 0,
                createdBy: localStorage.getItem("userId"),
                updatedBy: localStorage.getItem("userId"),
                name: null,
                description: "",
                elementDetail: {
                  id: 0,
                  createdBy: localStorage.getItem("userId"),
                  updatedBy: localStorage.getItem("userId"),
                  formId: 0,
                  elementId: 0,
                  value: "",
                  description: "",
                  effectiveDate: null,
                  endDate: null,
                  code: "",
                  fileName: "",
                  filePath: "",
                  base64String: "",
                },
                code: "",
              },
            ];

      reset({
        facilityId: id || 0,
        facilityDescription: description || "",
        facilityDetailDescription: detailDescription || "",
        dimensions: dimensions || "",
        settingCapacity: seatingCapacity?.toString() || "",
        facilityCategory: categoryId || null,
        availableFacilities: availableFacilityIds || [],
        assignResource: resourceIds || [],
        availabeDays: availableDays || [],
        peakBookingTime: peakBookingTime,
        offPeakBookingTime: offPeakBookingTime,
        peakBookingRate: peakBookingRate,
        OffpeakBookingRate: OffpeakBookingRate,
        createdBy: createdBy || localStorage.getItem("userId"),
        updatedBy: id !== 0 ? localStorage.getItem("userId") : null,
        elements: mappedElements,
      });
    } catch (error) {
      console.error("Error fetching facility data:", error);
    }
  };

  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this level's detail?"
    );

    if (confirmDelete) {
      try {
        const response = await del(`Facility/${rowId}?user=${user}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "text",
        });

        if (response === "Deleted") {
          toast.success(response.message || "Deleted!");
          fetchFacilities();
        } else {
          toast.error(response.message || "An error occurred while deleting.");
        }
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };

  return (
    <div className="container-fluid">
      <div className="row g-3">
        <div className="col-md-6">
          <div className="card h-100">
            <div className="card-body">
              <h4 className="mb-3 fs-8">Facility Registration</h4>

              <form className="row g-3" onSubmit={handleSubmit(saveData)}>
                <div className="col-md-6">
                  <label className="form-label">
                    Facility Description{" "}
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("facilityDescription", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                  />
                  {errors.facilityDescription && (
                    <small className="text-danger">
                      {errors.facilityDescription.message}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Facility Detail Description{" "}
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("facilityDetailDescription", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                  />
                  {errors.facilityDetailDescription && (
                    <small className="text-danger">
                      {errors.facilityDetailDescription.message}
                    </small>
                  )}
                </div>

                {renderDropdownS(
                  "facilityCategory",
                  "Facility Category",
                  facilityCategoryOptions
                )}

                <div className="col-md-6">
                  <label className="form-label">
                    Dimensions <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("dimensions", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                  />
                  {errors.dimensions && (
                    <small className="text-danger">
                      {errors.dimensions.message}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    Capacity <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("settingCapacity", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                  />
                  {errors.settingCapacity && (
                    <small className="text-danger">
                      {errors.settingCapacity.message}
                    </small>
                  )}
                </div>

                {renderDropdown(
                  "availableFacilities",
                  "Facilities available in this facility",
                  availableFacilitiesOptions
                )}

                {renderDropdown(
                  "peakBookingTime",
                  "Peak Booking Time",
                  peakBookingOptions
                )}

                {renderDropdown(
                  "offPeakBookingTime",
                  "Off Peak Booking Time",
                  offPeakBookingOptions
                )}

                <div className="col-md-6">
                  <label className="form-label">
                    Peak booking time rate per hour{" "}
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("peakBookingRate", {
                      required: "This field is required.",
                    })}
                    type="number"
                    className="form-control"
                  />
                  {errors.peakBookingRate && (
                    <small className="text-danger">
                      {errors.peakBookingRate.message}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">
                    OFF peak booking time rate per hour{" "}
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("OffpeakBookingRate", {
                      required: "This field is required.",
                    })}
                    type="number"
                    className="form-control"
                  />
                  {errors.OffpeakBookingRate && (
                    <small className="text-danger">
                      {errors.OffpeakBookingRate.message}
                    </small>
                  )}
                </div>

                {renderDropdown(
                  "availabeDays",
                  "Facility Available (Days)",
                  availabeDays
                )}
                {renderDropdown(
                  "assignResource",
                  "Focal Person",
                  assignResourceOptions
                )}

                <div className="col-12">
                  <button type="submit" className="btn btn-primary">
                    {facilityId === 0 ? "Save" : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card h-100">
            <div className="card-body">
              <div className="d-flex justify-content-end mb-3">
                <div className="d-flex align-items-start gap-2">
                  <button
                    type="button"
                    data-bs-toggle="tooltip"
                    title="Export to Excel"
                    className="btn btn-outline-success px-2 py-1"
                    onClick={exportToExcel}
                  >
                    <i className="fs-8 fa fa-file-excel"></i>
                  </button>
                  <button
                    type="button"
                    data-bs-toggle="tooltip"
                    title="Export to PDF"
                    className="btn btn-outline-danger px-2 py-1"
                    onClick={exportToPDF}
                  >
                    <i className="fs-8 fa fa-file-pdf"></i>
                  </button>
                </div>
              </div>

              <CustomDatatableGrid
                columns={columns}
                data={filteredData}
                onExportExcel={exportToExcel}
                onExportPDF={exportToPDF}
                initialState={{
                    columnPinning: { right: ["actions"] },
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row g-3 mt-3">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <Elements
                fields={fields}
                control={control}
                register={register}
                errors={errors}
                watch={watch}
                elementsData={elementsData}
                append={append}
                remove={remove}
                handleAttachmentFileChange={handleAttachmentFileChange}
                fileCounts={fileCounts}
                fileUrls={fileUrls}
                setValue={setValue}
                getValues={getValues}
                trigger={trigger}
              />
            </div>
          </div>
        </div>
      </div>

      {isCustomDropdownValuesModalVisible && (
        <FacilityDropdownWithCustomModal
          dropdownName={customDropdownName}
          onClose={() => {
            setIsCustomDropdownValuesModalVisible(false);
            switch (customDropdownName) {
              case "facilityCategory":
                fetchCommonSettings(
                  "facilityCategory",
                  setFacilityCategoryOptions
                );
                break;
              case "availableFacilities":
                fetchCommonSettings(
                  "availableFacilities",
                  setAvailableFacilitiesOptions
                );
                break;
              case "peakBookingTime":
                fetchCommonSettings("peakBookingTime", setPeakBookingOptions);
                break;
              case "offPeakBookingTime":
                fetchCommonSettings(
                  "offPeakBookingTime",
                  setOffPeakBookingOptions
                );
                break;
              case "assignResource":
                fetchCommonSettings("assignResource", setAssignResourceOptions);
                break;
              case "availabledays":
                fetchCommonSettings("availabledays", setAvailabeDays);
                break;
              default:
                break;
            }
          }}
        />
      )}
    </div>
  );
};

export default FacilityForm;
